import { useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

export function api(path) {
  return `${API}${path}`;
}

export function authHeaders() {
  const t = localStorage.getItem("admin_token");
  return t ? { Authorization: `Bearer ${t}` } : {};
}

export async function login(email, password) {
  const { data } = await axios.post(api("/api/auth/login"), { email, password });
  localStorage.setItem("admin_token", data.token);
  localStorage.setItem("admin_email", data.email);
  return data;
}

export function logout() {
  localStorage.removeItem("admin_token");
  localStorage.removeItem("admin_email");
}

export function isLoggedIn() {
  return !!localStorage.getItem("admin_token");
}

axios.interceptors.response.use(
  (r) => r,
  (err) => {
    const url = err?.config?.url || "";
    if (err?.response?.status === 401 && (url.includes("/api/admin") || url.includes("/api/auth/me")) && localStorage.getItem("admin_token")) {
      logout();
      sessionStorage.setItem("admin_notice", "Your session expired, please sign in again.");
      window.location.assign("/admin/login");
    }
    return Promise.reject(err);
  },
);

export function useSiteData() {
  const [data, setData] = useState({
    projects: [],
    social: [],
    articles: [],
    content: {},
    loading: true,
  });

  const reload = useCallback(async () => {
    try {
      const [p, s, a, c] = await Promise.all([
        axios.get(api("/api/projects")),
        axios.get(api("/api/social")),
        axios.get(api("/api/articles")),
        axios.get(api("/api/content")),
      ]);
      setData({
        projects: p.data,
        social: s.data,
        articles: a.data,
        content: c.data,
        loading: false,
      });
    } catch (e) {
      console.error("site-data load failed", e);
      setData((d) => ({ ...d, loading: false }));
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  return { ...data, reload };
}

export function fmtError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Something went wrong.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(d);
}
